import { FolderTree } from 'lucide-react';
import { Label } from '../../../../components/ui/label';
import { RadioGroup, RadioGroupItem } from '../../../../components/ui/radio-group';
import {
  ObjectExplorerGroupingMode,
  useAppStore,
} from '../../../../store/appStore';

const OPTIONS: Array<{
  value: ObjectExplorerGroupingMode;
  label: string;
  description: string;
}> = [
  {
    value: 'auto',
    label: 'Auto',
    description:
      'Show schemas as top-level folders when the database has more than one schema and more than 15 objects.',
  },
  {
    value: 'always',
    label: 'Always',
    description: 'Always show schemas as top-level folders.',
  },
  {
    value: 'never',
    label: 'Never',
    description:
      'Always show a flat list of objects, regardless of how many schemas the database has.',
  },
];

export function ObjectExplorerSettingsSection() {
  const mode = useAppStore((s) => s.objectExplorerGrouping);
  const setMode = useAppStore((s) => s.setObjectExplorerGrouping);

  return (
    <div className="space-y-3">
      <div className="text-sm font-medium">Object Explorer</div>

      <div className="rounded-md border border-border bg-background p-4 space-y-3">
        <div className="flex items-start gap-3">
          <FolderTree className="h-5 w-5 text-muted-foreground mt-0.5" />
          <div className="grid gap-0.5">
            <Label className="cursor-default">Group by schema</Label>
            <div className="text-xs text-muted-foreground">
              Choose how Tables, Views, and Programmability are organized in the sidebar tree
              for databases that use multiple schemas.
            </div>
          </div>
        </div>

        <RadioGroup
          value={mode}
          onValueChange={(v) => setMode(v as ObjectExplorerGroupingMode)}
          className="ml-8 space-y-2"
          data-testid="object-explorer-grouping-radio"
        >
          {OPTIONS.map((opt) => (
            <div key={opt.value} className="flex items-start gap-2">
              <RadioGroupItem
                id={`oeg-${opt.value}`}
                value={opt.value}
                data-testid={`object-explorer-grouping-${opt.value}`}
              />
              <div className="grid gap-0.5">
                <Label htmlFor={`oeg-${opt.value}`} className="cursor-pointer">
                  {opt.label}
                </Label>
                <div className="text-xs text-muted-foreground">{opt.description}</div>
              </div>
            </div>
          ))}
        </RadioGroup>
      </div>
    </div>
  );
}
